<template lang="pug">
  van-popup.van-popup--full(
    v-model="languagesShow"
    position="right"
    :overlay="false")

    van-nav-bar(
      :title="$t('settings.language')"
      left-arrow
      @click-left="$emit('close')"
    )

    .main
      van-cell-group
        van-cell(
          v-for="(lang, key) in languages"
          :title="lang"
          :key="key"
          @click="setLangUser(key)")
          van-icon(
            v-if="key === language"
            slot="right-icon"
            name="save"
            class="van-cell__right-icon text-brand")
</template>

<script>
import i18n from '@/locales/i18n';
import { mapGetters, mapActions } from 'vuex';
import { LANGUAGE } from '@/app.config';
import { getErrorId } from '@/services/error.service';
import UserService from '@/services/user.service';

export default {
  data() {
    return {
      languagesShow: true,
      languages: LANGUAGE.LANGUAGES,
      settingsError: null,
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      language: 'globalModule/getLanguage',
    }),
  },
  methods: {
    ...mapActions({
      setLanguage: 'globalModule/setLanguage',
    }),

    async setLangUser(lang) {
      try {
        // Compruebo si hay una petición en curso,
        // si la hay, no hago nada
        if (this.isLoading) return;

        // Muestro el loader
        this.$toast.loading({
          duration: 0,
          mask: true,
          message: i18n.t('general.loading'),
        });

        // Inicializo valores
        this.isLoading = true;
        this.settingsError = null;

        // Realizo la petición
        const settings = {
          language: lang,
        };

        await UserService.settings(settings);

        this.setLanguage(lang);
        this.$toast.clear();
      } catch (error) {
        // Obtengo el error
        this.settingsError = getErrorId(error);

        this.$toast.clear();
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
